import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { AssetInterface, setEditId, setEditError, selectAssetById } from "../../../store/mine_craft/assetsSlice";
import { updateAsset, fetchAsset } from "../../../actions/mine_craft/assetsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch = useAppDispatch();
  const location = useLocation();
  const id: any = useAppSelector(state => state.mineCraft.assets.editId);
  const error = useAppSelector(state => state.mineCraft.assets.editError);
  const asset = useAppSelector(state => id ? selectAssetById(state, id) : undefined);
  const params: any = { ...asset };

  useEffect(() => {
    if (id) {
      dispatch(fetchAsset(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(rawData: any) {
    const data = { ...rawData };

    handleSave(data).catch(console.error);
  }

  async function handleSave(data: AssetInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateAsset({ id, data: formData }));

    if (updateAsset.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-asset'>
        <h6 className="v-content-label">Edit Avatar</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={params} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
